module.exports = __webpack_public_path__ + "static/media/fi-rr-list-check.2d18bc6f.svg";